module.exports = __webpack_public_path__ + "static/media/rebel.751d40ec.png";